'use strict';

export const BUTTON_STATES = {
  START: 0,
  CONFIRM: 1,
  LOADING: 2,
  WORKING: 2,
  SUCCESS: 3,
  FAILURE: 4, /* Deprecated */
  ERROR: 4,
};



// WEBPACK FOOTER //
// ./src/js/core-components/transforming-buttons/CONFIRM_BUTTON_STATES.js